import { PageLayout } from "layouts";
import { Home, AboutUs, OurProducts, ContactUs } from "pages";

export const getRoutes = () => [
  {
    element: <PageLayout />,
    path: "",
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "about-us",
        element: <AboutUs />,
      },
      {
        path: "our-products",
        element: <OurProducts />,
      },
      {
        path: "contact-us",
        element: <ContactUs />,
      },
    ],
  },
];
